import { Box } from "@mui/material";
import React, { FC, ReactNode } from "react";

type ConfirmBoxProps = {
  children: ReactNode;
};

const ConfirmBox: FC<ConfirmBoxProps> = ({ children }) => {
  return (
    <Box
      border={1}
      borderColor="grey.400"
      borderRadius={2}
      p={1}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
      mt={10}
      mb={5}
      sx={{ maxWidth: "600px", width: "100%" }}
    >
      {children}
    </Box>
  );
};

export default ConfirmBox;
